import styled from 'styled-components';
import media from '../../../../constants/media';
import { Columns } from '../../../base/grid';
import { P, Strong as StyledStrong } from '../../../base/typography';

export const Wrapper = styled.div``;

export const FieldColumns = styled(Columns)``;

export const Strong = styled(StyledStrong)`
	margin-right: 5px;
`;

export const SubmissionFailed = styled.div`
	margin-top: 3rem;
	font-size: 2rem;
	text-align: center;
	color: ${({ theme }) => theme.colors.primary};
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 6rem;

	${media.mobileOnly`
		flex-direction: column;
		margin-right: 0;

		button {
			width: 100%;

			&:first-child {
				margin-bottom: 1.5rem;
			}
		}
	`};
`;

export const CountryWrapper = styled.div`
	display: flex;
	align-items: center;

	img {
		width: 2.5rem;
		transform: translateY(-4px);
		margin-right: 0.5rem;
	}
`;

export const RedP = styled(P)`
	color: ${({ theme }) => theme.colors.primary};
`;

export const HelperText = styled(P)`
	font-size: 1.5rem;
	margin-bottom: 0;
`;

export const ContentCard = styled.div`
	height: 100%;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	border-radius: 8px;
	padding: 1.5rem;
	box-sizing: border-box;
`;

export const SectionDivider = styled.hr`
	width: 100%;
	border: none;
	border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
	margin: 0;
`;
